var map = {
	"./music-instructions.json": 3071,
	"./music-library-intro2024.json": 3072,
	"./music-library-launch2024.json": 3073,
	"./music-progression.json": 3074,
	"./startSourcesAdvanced.json": 3075,
	"./startSourcesSimple.json": 3076,
	"./startSourcesSimple2.json": 3077,
	"./startSourcesTracks.json": 3078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2857;